<template>
    <div class="guide">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <h1>How to Use this Resource</h1>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <p>The North Coast Resource Hub features many resources located in Humboldt County related to social and medical care, with a particular focus on pregnant women and substance use. </p>
                    <p><strong>To facilitate website navigation, filters can be applied to narrow search results:</strong></p>
                    <img src="@/assets/guide-images/filters.png">
                    <p><strong>What is a filter?</strong> A filter is a word of phrase that will narrow your search results to more closely match what you are searching for. The more filters that are applied, the narrower the search results will be. Apply <em>more</em> filters when you are looking for very specific resources. Apply <em>less</em> resources when you searching broadly.</p>
                    <p>There are several different types of filters you can choose from:</p>
                    <ul class="guide-list">
                        <li>
                            <strong>Text Search:</strong> Simply type key words associated with the result you are looking for. This filter works best when you know the name of the program/organization you are looking for.
                            <br />
                            <strong>For example:</strong> I am looking for the food bank. Type: “Food for People”
                        </li>

                        <li>
                            <strong>Geographic Filter:</strong> Type the name of a city, and from the drop-down menu, select the number of miles you would like to include in the search radius
                            <br />
                            <strong>For example:</strong> My client does not have transportation and they live in Arcata. Type: “Arcata” in the geographic filter. Click details on a resource to view a map that links to bus routes and schedules.
                        </li>
                        <li>
                            <strong>Sub-population Filter:</strong> Choose from the drop-down menu the result that best matches the client you are serving.
                            <br />
                            <strong>For example:</strong> I am working with a pregnant person. Select “Pregnant people” from the drop-down menu
                        </li>
                        <li>
                            <strong>Insurance Type Filter:</strong> If you know your client’s insurance type, you may apply this filter to narrow down resources that accept their insurance and include no-cost services.
                            <br />
                            <strong>For example:</strong> My client has Medi Cal and is looking for resources. Select “Medi Cal” from the drop-down menu to view both, resources that accept Medi Cal and are no cost to client (i.e. do not bill insurance)
                        </li>
                    </ul>
                    <p><strong>The section below provides more detail about various parts of the platform:</strong></p>
                    <p>Clicking the green detail button directs you the map (if applicable), hours of operation, contact information, and more. The blue link button directs to the website associated with that resource.</p>
                    <img src="@/assets/guide-images/resource.png">
                    <img src="@/assets/guide-images/details.png">
                    <p>If you have any questions on how to use the North Coast Resource Hub, please contact Kerri Escudero at <a href="mailto:KEscudero@nchiin.org?Subject=Resource%20Hub%20Inquiry">KEscudero@nchiin.org</a> or (707)443-4563</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Guide.vue"
    }
</script>

<style scoped>
    .guide-list {
        list-style-position: outside;
    }
    .guide-list > li {
        margin-bottom: 10px;
        padding-left: 10px;
    }
    .guide-image {
        max-width: 100%;
    }
</style>